// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3uQzY","gfeWrapper":"CalendarEvent_gfeWrapper__1t3yz"};